// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__33wji","mainText":"MainPage_mainText__figXn","videoWrap":"MainPage_videoWrap__EzITT","codingImg":"MainPage_codingImg__Dj+IL"};